// extracted by mini-css-extract-plugin
export default {"waitingForProvider":"unavailable_waitingForProvider__dkRaZ"};